<template>
  <div>
    <v-app-bar
      id="appbar"
      app flat
      class="mhr-appbar"
      :class="isMobile || !(isHome && elements['mhr-hero']) ? 'mhr-blue-transparent mhr-appbar-padded' : 'transparent'"
    >
      <base-img
        v-show="isMobile || !(isHome && elements['mhr-hero'])"
        contain
        src="/assets/logo/mhr-white.svg"
        class="mhr-appbar-logo"
      />

      <div class="fill-height" :class="isMobile || !(isHome && elements['mhr-hero']) ? 'ms-auto' : 'mx-auto'">
        <v-tabs
          class="hidden-md-and-down fill-height"
          optional hide-slider height="100%"
          background-color="transparent"
        >
          <template v-for="(name, i) in items">
            <v-menu
              v-if="name === 'Our Brands'"
              :key="name"
              v-model="activeBrands"
              bottom offset-y tile open-on-hover
              content-class="elevation-0 hidden-md-and-down"
            >
              <template #activator="{ on, attrs }">
                <v-tab
                  class="mhr-appbar-tab mhr-white--text"
                  :style="{ backgroundColor: activeBrands ? '#fafafa0a' : 'transparent'}"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ name }}
                  <v-icon color="mhr-white">
                    {{ activeBrands ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                  </v-icon>
                </v-tab>
              </template>
              <v-tabs
                vertical hide-slider
                :background-color="isHome && elements['mhr-hero'] ? '#fafafa0a' : 'mhr-blue-transparent'"
              >
                <v-tab
                  v-for="name in brands"
                  :key="name"
                  :to="{ name }"
                  :ripple="false"
                  text
                  class="mhr-appbar-tab mhr-white--text justify-start"
                  v-text="name"
                />
              </v-tabs>
            </v-menu>
            <v-tab
              v-else
              :key="i"
              :to="{ name }"
              :ripple="false"
              class="mhr-appbar-tab mhr-white--text"
              min-width="96"
              text
              v-text="name"
            />
          </template>
        </v-tabs>
      </div>

      <v-btn
        tile elevation="0"
        class="hidden-lg-and-up mhr-appbar-nav mhr-blue white--text"
        @click="drawer = !drawer"
      >
        <v-icon large>
          {{ drawer ? 'mdi-close' : 'mdi-menu' }}
        </v-icon>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      width="100%"
      right app clipped hide-overlay
      class="d-lg-none mhr-appbar-drawer elevation-0 pt-16 text-end"
      color="mhr-blue-transparent"
    >
      <v-list class="pa-0">
        <template v-for="(name, i) in items">
          <div v-if="name === 'Our Brands'" :key="i">
            <v-list-item
              class="mhr-white--text text-uppercase mhr-text-drawer justify-end px-12 py-4"
              @click="activeBrands = !activeBrands"
            >
              {{ name }}
              <v-icon color="mhr-white">
                {{ activeBrands ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
              </v-icon>
            </v-list-item>
            <v-expand-transition>
              <div v-show="activeBrands">
                <v-list class="pa-0">
                  <v-list-item
                    v-for="name in brands"
                    :key="name"
                    :to="{ name }"
                    class="mhr-white--text text-uppercase mhr-text-drawer-2 justify-end px-16 py-2"
                    v-text="name"
                  />
                </v-list>
              </div>
            </v-expand-transition>
          </div>
          <v-list-item
            v-else
            :key="name"
            class="mhr-white--text text-uppercase mhr-text-drawer justify-end px-13 py-4"
            :to="{ name }"
            v-text="name"
          />
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-slide-y-reverse-transition>
      <v-btn
        v-show="!elements['mhr-hero'] || !isOnTop"
        fab tile fixed bottom right
        class="white--text"
        color="mhr-blue"
        @click="$vuetify.goTo(0)"
      >
        <v-icon>mdi-arrow-up</v-icon>
      </v-btn>
    </v-slide-y-reverse-transition>
  </div>
</template>

<script>
  export default {
    name: 'HomeAppBar',

    data: () => ({
      isOnTop: true,
      drawer: false,
      activeBrands: false,

      items: [
        'Home',
        'About Us',
        'Our Brands',
        'Dining',
        'Events',
        'Features',
        'Club Access'
      ],

      brands: [
        'All Brands',
        'Belmont',
        'Savoy',
        'Richmonde'
      ],

      elements: {
        'mhr-hero': true
      }
    }),

    computed: {
      isHome () { return this.$route.name === 'Home' }
    },

    mounted () {
      window.addEventListener('scroll', this.onScroll)
    },

    beforeDestroy () {
      window.removeEventListener('scroll', this.onScroll)
    },

    methods: {
      checkVisibilities () {
        // Check if at least half of element is visible
        const offset = document.getElementById('appbar').offsetHeight

        Object.keys(this.elements).forEach(i => {
          let el = document.getElementById(i)
          if (!el) return (this.elements[i] = false)
          const { offsetHeight } = el
          el = el.getBoundingClientRect()

          this.elements[i] =
            el.top - offset > -offsetHeight * 0.5 &&
            el.bottom < (window.innerHeight || document.documentElement.clientHeight) + offsetHeight * 0.5
        })
      },

      onScroll () {
        this.isOnTop = window.top.scrollY === 0
        this.checkVisibilities()
      }
    }
  }
</script>

<style lang="sass">
  #home-app-bar
    .v-tabs-slider
      max-width: 24px
      margin: 0 auto

    .v-tab
      &::before
        display: none
</style>
